import { LicenseManager } from "ag-grid-enterprise";

// License key for both AG Grid and AG Charts Enterprise
const LICENSE_KEY =
  "License_AG_Both[v3][0102]_MjA1NDY3ODQwMDAwMA==1b191d4780dd4a02a78bed89c8854741";

export const setupAgLicenses = () => {
  // Set AG Grid Enterprise license (this covers both AG Grid and AG Charts)
  LicenseManager.setLicenseKey(LICENSE_KEY);
};
